module.exports = __webpack_public_path__ + "static/media/red_popup.ec0f1cac.png";